import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class CIDSystemServerPlugin extends SmartenitPlugin {
    // Methods
    public setCode(index: number, code: string) {
        this.executeMethod(
            this.componentId,
            this.processorName,
            'SetCode',
            {
                Code: code,
                Index: index,
            },
            false
        );
    }

    public getCode(index: number) {
        this.executeMethod(
            this.componentId,
            this.processorName,
            'GetCode',
            {
                Index: index,
            },
            false
        );
    }

    public dropApsLinkKey(ieeeAddress: string) {
        this.executeMethod(
            this.componentId,
            this.processorName,
            'DropApsLinkKey',
            {
                IEEEAddress: ieeeAddress
            },
            false
        );
    }
    public registerApsLinkKey(ieeeAddress: string, apsLinkKey: string) {
        this.executeMethod(
            this.componentId,
            this.processorName,
            'RegisterApsLinkKey',
            {
                APSLinkKey: apsLinkKey,
                IEEEAddress: ieeeAddress
            },
            false
        );
    }

    public getApsLinksTable() {
        this.executeMethod(
            this.componentId,
            this.processorName,
            'GetApsLinksTable',
            {},
            false
        );
    }

    public getNetworkTopology() {
        this.executeMethod(
            this.componentId,
            this.processorName,
            'GetNetworkTopology',
            {},
            false
        );
    }

    public ping() {
        this.executeMethod(
            this.componentId,
            this.processorName,
            'Ping',
            {},
            false
        );
    }

    // General

    public getStatusPayload(): any {
        return [];
    }

    public getStatus(): void { }

    public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
        const response = message && message.data && message.data.response;
        const attribute = message && message.attributeOrMethod;

        if (attribute === 'SetCodeResponse') {
            this._onUpdate.next({ setCodeResponse: response.value });
        } else if (attribute === 'GetCodeResponse') {
            this._onUpdate.next({ getCodeResponse: response.value });
        } else if (attribute === 'DropApsLinkKeyResponse') {
            this._onUpdate.next({ dropApsLinkKeyResponse: response.value });
        } else if (attribute === 'RegisterApsLinkKeyResponse') {
            this._onUpdate.next({ registerApsLinkKeyResponse: response.value });
        } else if (attribute === 'GetApsLinksTableResponse') {
            this._onUpdate.next({ getApsLinkTableResponse: response.value });
        } else if (attribute === 'GetNetworkTopologyResponse') {
            this._onUpdate.next({ getNetworkTopologyResponse: response.value });
        } else if (attribute === 'PingResponse') {
            this._onUpdate.next({ pingResponse: response.value });
        }
    }
}
